import React from 'react';
import '../styles/PotteryCollection.css';

const PotteryCollection = ({ potteryItems, currentLang, onItemClick }) => {
    const getImageSrc = (img, imageType) => {
        if (imageType === 'base64' || (img && img.startsWith('data:image'))) {
            return img;
        }
        return `${process.env.PUBLIC_URL}/${img}`;
    };
    return (
        <section className="pottery-collection-section">
            <h2 className="section-title">
                {currentLang === 'ar' ? 'مجموعة الفخار' : 'Our Pottery Collection'}
            </h2>
            <div className="pottery-items-grid">
                {potteryItems.length === 0 ? (
                    <p className="no-items">
                        {currentLang === 'ar' ? 'لا توجد قطع فخار متاحة' : 'No pottery items available'}
                    </p>
                ) : (
                    potteryItems.map((item) => {
                        const mainImage = item.images && item.images.length > 0 
                            ? item.images[0] 
                            : (item.image || 'pottery1.jpg');
                        const stockText = item.stock === 'in_stock'
                            ? (currentLang === 'ar' ? 'متوفر' : 'In Stock')
                            : (currentLang === 'ar' ? 'غير متوفر' : 'Out of Stock');
                        const stockClass = item.stock === 'in_stock' ? 'stock-in' : 'stock-out';
                        const imageSrc = getImageSrc(mainImage, item.imageType);

                        return (
                            <div
                                key={item.id}
                                className="pottery-item-thumbnail"
                                onClick={() => onItemClick(item)}
                            >
                                <img
                                    src={imageSrc}
                                    alt={currentLang === 'ar' ? item.titleAr : item.titleEn}
                                    className="pottery-thumbnail-image"
                                    loading="lazy"
                                    onError={(e) => {
                                        console.error('Image failed to load:', mainImage);
                                        if (item.imageType !== 'base64') {
                                            e.target.src = `${process.env.PUBLIC_URL}/pottery1.jpg`;
                                        }
                                    }}
                                />
                                <div className="pottery-thumbnail-content">
                                    <h3 className="pottery-thumbnail-title">
                                        {currentLang === 'ar' ? item.titleAr : item.titleEn}
                                    </h3>
                                    <div className="pottery-thumbnail-price">
                                        {item.price || 'N/A'} {item.currency || 'KWD'}
                                    </div>
                                    <div className={`pottery-thumbnail-stock ${stockClass}`}>
                                        {stockText}
                                    </div>
                                </div>
                            </div>
                        );
                    })
                )}
            </div>
        </section>
    );
};

export default PotteryCollection;

